module.exports = __webpack_public_path__ + "img/coin-adjustment-in.3cbe0ea9.png";